import axios from "./axios-profile";

const config = {};

const apiEndpoint = () =>
  `${document.location.protocol}//${document.location.hostname}/api`;

const createFormData = (data) => {
  const payrollKeys = [
    "bankName",
    "accountName",
    "sortCode",
    "accountNumber",
    "nationalInsuranceNo",
  ];

  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    const itemExists = !!data[key];
    const itemIsFalse = data[key] === false;
    const itemIsBankItem = payrollKeys.indexOf(key) > -1;
    const shouldKeep = itemIsBankItem || itemExists || itemIsFalse;
    if (shouldKeep) {
      formData.append(key, data[key]);
    }
    // data[key] || data[key] === false ? formData.append(key, data[key]) : null
  });
  return formData;
};

export const createUser = (userData) => {
  const formData = createFormData(userData);
  return axios.post("/candidate", formData, {
    ...config,
  });
};

export const updateUser = (userData, onProgress) => {
  const formData = createFormData(userData);
  return axios.put(`/candidate`, formData, {
    ...config,
    onUploadProgress: onProgress,
  });
};

export const getUser = () => axios.get("/candidate");

export const getTimesheets = () =>
  axios.get("/membersArea/timesheets?take=400");

export const getBookings = () => axios.get("/membersArea/bookings");

export const updateTimesheet = (
  timesheet,
  sendTimesheetNotification = false
) => {
  const data = { timesheet, submitted: sendTimesheetNotification };
  return axios.put("/membersArea/timesheet", data, {
    ...config,
  });
};

export const sendBranchEmail = (email) => {
  const data = { email };
  axios.post(`/membersArea/branchNotification`, data, {
    ...config,
  });
};

export const submitRightToWork = (payload) =>
  axios.post(`/membersArea/rightToWorkCheck`, payload, {
    ...config,
  });

export const uploadDocumentation = (payload) =>
  axios.post(`/membersArea/documentation`, payload, {
    ...config,
  });

export const postReflexAllenOnboardingForm = (payload) =>
  axios.post(`membersArea/onlineForm`, payload, {
    ...config,
  });

export const getReflexAllenPdf = (formCode) =>
  axios.get(`membersArea/onlineForm?formId=${formCode}`, {
    ...config,
    responseType: "blob",
  });

export const postReflexAllenInductionProgramme = (content) =>
  axios.post(`membersArea/checklist`, content, {
    ...config,
  });

export const getRTWVerificationQueueSize = () =>
  axios.get("/membersArea/verificationCallQueueSize");

export const getRTWVerificationQueueRegister = () =>
  axios.post("/membersArea/createVerificationCall", {});

export const getRTWVerificationQueuePosition = (queueToken) =>
  axios.get(`/membersArea/verificationCallQueueStatus/${queueToken}`);

export const postThanetCouncilForms = (formName, formContent) =>
  axios.post(`/membersArea/thanetCouncilOnboarding/${formName}`, formContent);

export const submitThanetCouncilForms = (formName, formContent) =>
  axios.post(
    `/membersArea/thanetCouncilOnboarding/submit/${formName}`,
    formContent
  );

export const postRoyalMailForm = (formName, formContent) =>
  axios.post(`/membersArea/royalMailOnboarding/${formName}`, formContent);

export const postDnataForm = (formName, formContent) =>
  axios.post(`/membersArea/dnataOnboarding/${formName}`, formContent);
export const submitDnataExtraForm = (formName, formContent) =>
  axios.post(`/membersArea/dnataOnboarding/submit/${formName}`, formContent);

export const postGateForm = (formName, formContent) =>
  axios.post(`/membersArea/gateOnboarding/${formName}`, formContent);

export const submitGateForm = (gateContent) =>
  axios.post(`/membersArea/gateOnboarding/submit`, gateContent);

export const getGateForm = () =>
  axios.get(`/membersArea/gateOnboarding/pdf`, {
    responseType: "arraybuffer",
  });

export const postSwissportForm = (formName, formContent) =>
  axios.post(`/membersArea/swissportOnboarding/${formName}`, formContent);

export const postPecanForms = (formName, formContent) =>
  axios.post(`/membersArea/pecanOnboarding/${formName}`, formContent);

export const postSOPKingspan = (formName, formContent) =>
  axios.post(`/membersArea/kingspanOnboarding/${formName}`, formContent);

export const postSSOWCarltonForest = (formName, formContent) =>
  axios.post(
    `/membersArea/carltonForestOnboarding/ssow/${formName}`,
    formContent
  );

export const postCarltonForestForm = (formName, formContent) => {
  return axios.post(
    `/membersArea/carltonForestOnboarding/${formName}`,
    formContent
  );
};

export const submitCarltonForestForm = (formName, formContent) => {
  return axios.post(
    `/membersArea/carltonForestOnboarding/submit/${formName}`,
    formContent
  );
};

export const postRegattaForms = (formName, formContent) => {
  return axios.post(`/membersArea/regattaOnboarding/${formName}`, formContent);
};

export const submitRegattaForms = (formName, formContent) => {
  return axios.post(
    `/membersArea/regattaOnboarding/submit/${formName}`,
    formContent
  );
};

export const submitPecanAssessment = (testAnswers) =>
  axios.post(`/membersArea/pecanOnboarding/submitAssessment`, testAnswers);

export const submitPecanForms = (content) =>
  axios.post(`/membersArea/pecanOnboarding/submit`, content);

export const submitDnataForm = (dnataContent) =>
  axios.post(`/membersArea/dnataOnboarding/submit`, dnataContent);

export const submitDnataTest = (testAnswers) =>
  axios.post(`/membersArea/dnataOnboarding/submitTest`, testAnswers);

export const getDnataForm = () =>
  axios.get(`/membersArea/dnataOnboarding/pdf`, {
    responseType: "arraybuffer",
  });

export const getSwissportForm = (formName) =>
  axios.get(`/membersArea/swissportOnboarding/getPdf/${formName}`, {
    responseType: "arraybuffer",
  });

export const getRegattaSignatureDocs = (url, name) =>
  axios.post(
    `/membersArea/getOnFlyPDF`,
    {
      url,
      name,
    },
    {
      responseType: "arraybuffer",
    }
  );

export const submitRoyalMailOnboarding = (royalMailContent) =>
  axios.post(`/membersArea/royalMailOnboarding/submit`, royalMailContent);

export const downloadRoyalMailForm = () =>
  axios.get(`/membersArea/royalMailOnboarding/pdf`, {
    responseType: "arraybuffer",
  });

export const postDrivingForm = (formName, formContent) =>
  axios.post(`/membersArea/drivingOnboarding/${formName}`, formContent);

export const postNightWorkerForm = (formName, formContent) =>
  axios.post(`/membersArea/resources/${formName}`, formContent, {
    params: { formName },
  });

export const postAuthorityForPaymentsForm = (formName, formContent) =>
  axios.post(`/membersArea/resources/${formName}`, formContent, {
    params: { formName },
  });

export const postNonverbalImmediacyTest = (answers, name) =>
  axios.post(
    `/membersArea/psychometricTests/nonverbalImmediacyHandler`,
    { answers },
    {
      params: { name },
    }
  );

export const postDiscAssessmentTest = (answers, name) =>
  axios.post(
    `/membersArea/psychometricTests/discAssessmentHandler`,
    { answers },
    {
      params: { name },
    }
  );

export const submitGLAAForms = (formContent) => {
  return axios.post(`/membersArea/glaaOnboarding/submit`, formContent);
};

export const getGLAAPDF = (idToken) =>
  axios.get(`/membersArea/glaaOnboarding/getPDF/YS01`, {
    responseType: "arraybuffer",
  });

export const postExposureBasedMemoryTest = (answers, name) =>
  axios.post(
    `/membersArea/psychometricTests/exposureBasedMemoryHandler`,
    { answers },
    {
      params: { name },
    }
  );

export const postBig5PersonalityTest = (answers, name) =>
  axios.post(
    `/membersArea/psychometricTests/big5PersonalityHandler`,
    { answers },
    {
      params: { name },
    }
  );

export const postDrivingAssessment = (assessmentName, name, answers) =>
  axios.post(`/membersArea/drivingOnboarding/${assessmentName}`, answers, {
    params: { name },
  });

export const submitDrivingOnboarding = (drivingContent) =>
  axios.post(`/membersArea/drivingOnboarding/submit`, drivingContent);

export const downloadDrivingForm = () =>
  axios.get(`/membersArea/drivingOnboarding/pdf`, {
    responseType: "arraybuffer",
  });

export const downloadPayrollKidPdf = (
  name,
  responsibleTeam,
  createdAt,
  index = 0
) =>
  axios.get(`/membersArea/keyInformationDocument/payroll`, {
    params: { name, responsibleTeam, index, createdAt },
    responseType: "arraybuffer",
  });

export const payrollKidPdfUrl = (
  name,
  responsibleTeam,
  createdAt,
  index = 0
) => {
  const url = new URL(
    `${apiEndpoint()}/membersArea/keyInformationDocument/payroll`
  );
  url.searchParams.append("name", name);
  url.searchParams.append("responsibleTeam", responsibleTeam);
  url.searchParams.append("index", index);
  url.searchParams.append("createdAt", createdAt);
  return url.href;
};

export const downloadHrGoKidPdf = (name, responsibleTeam, createdAt) =>
  axios.get(`/membersArea/keyInformationDocument/hr-go`, {
    params: { name, responsibleTeam, createdAt },
    responseType: "arraybuffer",
  });

export const hrgoKidPdfUrl = (name, responsibleTeam, createdAt) => {
  const url = new URL(
    `${apiEndpoint()}/membersArea/keyInformationDocument/hr-go`
  );
  url.searchParams.append("name", name);
  url.searchParams.append("responsibleTeam", responsibleTeam);
  url.searchParams.append("createdAt", createdAt);
  return url.href;
};

export const downloadHrGoPlcKidPdf = (name, responsibleTeam, createdAt) =>
  axios.get(`/membersArea/keyInformationDocument/hr-go-plc`, {
    params: { name, responsibleTeam, createdAt },
    responseType: "arraybuffer",
  });

export const downloadNewHrGoPlcKidPdf = (name, responsibleTeam, createdAt) =>
  axios.get(`/membersArea/keyInformationDocument/hr-go-plc/new`, {
    params: { name, responsibleTeam, createdAt },
    responseType: "arraybuffer",
  });

export const hrgoPlcKidPdfUrl = (name, responsibleTeam, createdAt) => {
  const url = new URL(
    `${apiEndpoint()}/membersArea/keyInformationDocument/hr-go-plc`
  );
  url.searchParams.append("name", name);
  url.searchParams.append("responsibleTeam", responsibleTeam);
  url.searchParams.append("createdAt", createdAt);
  return url.href;
};

export const newHrgoPlcKidPdfUrl = (name, responsibleTeam, createdAt) => {
  const url = new URL(
    `${apiEndpoint()}/membersArea/keyInformationDocument/hr-go-plc/new`
  );
  url.searchParams.append("name", name);
  url.searchParams.append("responsibleTeam", responsibleTeam);
  url.searchParams.append("createdAt", createdAt);
  return url.href;
};

export const downloadResourcePdf = (formName, completed = false) =>
  axios.get(`/membersArea/resources/${formName}`, {
    params: { completed },
    responseType: "arraybuffer",
  });

export const resourcePdfUrl = (formName, completed) => {
  const url = new URL(`${apiEndpoint()}/membersArea/resources/${formName}`);
  url.searchParams.append("completed", completed);
  return url.href;
};

export const submitResourceAgreement = (name, formName) =>
  axios.post(
    `/membersArea/resources/${formName}`,
    {},
    {
      params: { name },
      responseType: "arraybuffer",
    }
  );

export const updateDetailsPrompt = (date) =>
  axios.put(
    `/membersArea/prompts/updateDetails`,
    {},
    {
      params: { date },
    }
  );

export const downloadTestFeedback = (testName) =>
  axios.get(`/membersArea/psychometricTests/${testName}Handler`, {
    responseType: "arraybuffer",
  });

export const testFeedbackUrl = (testName) => {
  const url = new URL(
    `${apiEndpoint()}/membersArea/psychometricTests/${testName}Handler`
  );
  url.searchParams.append("testName", testName);
  return url.href;
};

export const submitContractForServices = (
  name,
  address,
  typeOfWork,
  responsibleTeam,
  isDriver,
  createdAt
) =>
  axios.post(
    `/membersArea/contractForServices`,
    {},
    {
      params: {
        name,
        address,
        typeOfWork,
        responsibleTeam,
        isDriver,
        createdAt,
      },
      responseType: "arraybuffer",
    }
  );

export const downloadContractForServices = (completed, isDriver, createdAt) =>
  axios.get(`/membersArea/contractForServices`, {
    params: { createdAt, completed, isDriver },
    responseType: "arraybuffer",
  });

export const contractForServicesUrl = (
  formName,
  fileName,
  completed,
  isDriver,
  createdAt
) => {
  const url = new URL(`${apiEndpoint()}/membersArea/${formName}`);
  url.searchParams.append("fileName", fileName);
  url.searchParams.append("completed", completed);
  url.searchParams.append("isDriver", isDriver);
  url.searchParams.append("createdAt", createdAt);
  return url.href;
};

export const getGreatBearInductionPackPDF = () =>
  axios.get(`/membersArea/getGreatBearInductionPackPDF`, {
    responseType: "arraybuffer",
  });

export const getAssignmentDetails = () =>
  axios.get(`/membersArea/getAssignmentDetails`, {
    responseType: "arraybuffer",
  });

export const getKingspanDrugPolicyPDF = () =>
  axios.get(`/membersArea/getKingspanDrugPolicyPDF`, {
    responseType: "arraybuffer",
  });

export const getIpnForm = () =>
  axios.get(`/membersArea/getIpnForm`, {
    responseType: "arraybuffer",
  });

export const getPusterlaReadingPDF = () =>
  axios.get(`/membersArea/getPusterlaReadingPDF`, {
    responseType: "arraybuffer",
  });

export const postABMForm = (formName, formContent) =>
  axios.post(`/membersArea/abmOnboarding/${formName}`, formContent);

export const submitABMForm = (formContent) =>
  axios.post(`/membersArea/abmOnboarding/submit`, formContent);

export const getABMForm = () =>
  axios.get(`/membersArea/abmOnboarding/pdf`, {
    responseType: "arraybuffer",
  });

export const getPecanPDF = () =>
  axios.get(`/membersArea/pecanOnboarding/getPDF`, {
    responseType: "arraybuffer",
  });

export const getCarltonForestForm = () =>
  axios.get(`/membersArea/getCarltonForestForm`, {
    responseType: "arraybuffer",
  });

export const getPDF = (typeCode) =>
  axios.get(`/membersArea/getPDF/${typeCode}`, {
    responseType: "arraybuffer",
  });

export const postPusterlaForms = (formName, formContent) => {
  return axios.post(`/membersArea/pusterlaOnboarding/${formName}`, formContent);
};

export const submitPusterlaForms = (formName, formContent) => {
  return axios.post(
    `/membersArea/pusterlaOnboarding/submit/${formName}`,
    formContent
  );
};

export const getPusterlaPDF = (typeCode) =>
  axios.get(`/membersArea/pusterlaOnboarding/getPDF/${typeCode}`, {
    responseType: "arraybuffer",
  });

export const postGreatBearChecklist = (content) =>
  axios.post(`/membersArea/checklistGB`, content);

export const getGreatBearChecklistPDF = () =>
  axios.get(`/membersArea/checklistGB`, {
    responseType: "arraybuffer",
  });

export const markDocumentRead = (payload) =>
  axios.post(`/membersArea/readingList`, payload);

export const getEnrolledCourses = () => axios.get(`/membersArea/courses`);

export const enrollInCourse = (courseId) =>
  axios.post(`/membersArea/courses?courseId=${courseId}`, {});

export const getCourseLaunchLink = async (courseId) => {
  const { data } = await axios.get(
    `/membersArea/courses/link?courseId=${courseId}`
  );
  const { launchLink } = data;
  return launchLink;
};

export const authenticateCandidateWithZendesk = async () => {
  if (typeof window.zE === "function") {
    window.zE("webWidget", "chat:reauthenticate");
  }
};

export const postNHSReferencesForm = (formContent) =>
  axios.post("/membersArea/nhsReferencing", formContent);

export const postUmbrellaDeclarationFormSaga = (formContent) =>
  axios.post("/membersArea/umbrellaDeclaration", formContent);

export const getYotiSessionUrl = () => axios.get("/membersArea/yoti/session");
export const getYotiSessionUrlForJob = (jobId) =>
  axios.get(`/membersArea/yoti/session/${jobId}`);

export const postMolecularForms = (formName, formContent) =>
  axios.post(`/membersArea/molecularOnboarding/${formName}`, formContent);

export const postKingspanForms = (formName, formContent) =>
  axios.post(`/membersArea/kingspanOnboarding/submit/${formName}`, formContent);

export const postWoodlandForms = (formName, formContent) =>
  axios.post(`/membersArea/woodlandOnboarding/${formName}`, formContent);

export const postCompleatFoodForm = (formName, formContent) =>
  axios.post(`/membersArea/compleatFoodOnboarding/${formName}`, formContent);

export const getCompleatFoodSignatureDocs = (url, name) =>
  axios.post(
    `/membersArea/compleatFoodOnboarding/getOnFlyPDF`,
    {
      url,
      name,
    },
    {
      responseType: "arraybuffer",
    }
  );
export const postHolidayRequestForm = (formName, formContent) =>
  axios.post(`/membersArea/sendHolidayRequestForm/${formName}`, formContent);
export const submitGrowUpFarmsQuestionnaire = (formName, formContent) =>
  axios.post(
    `/membersArea/growUpFarmsOnboarding/submit/${formName}`,
    formContent
  );

export const postDavinFoodsForm = (formName, formContent) => {
  return axios.post(
    `/membersArea/davinFoodsOnboarding/${formName}`,
    formContent
  );
};
export const postIpnForm = (formName, formContent) => {
  return axios.post(`/membersArea/ipnOnboarding/${formName}`, formContent);
};
export const submitDavinFoodsForm = (formName, formContent) => {
  return axios.post(
    `/membersArea/davinFoodsOnboarding/form/${formName}`,
    formContent
  );
};
export const submitDavinFoodsQuiz = (formName, formContent) =>
  axios.post(`/membersArea/davinFoodsOnboarding/quiz/${formName}`, formContent);
